<template>
  <div class="cwSplitBoxItem">
    <div class="input-group">
      <slot name="prefix">
        <span class="input-group-addon" v-if="cmpConfig.component.decorator.label_prefix">{{
          cmpConfig.component.decorator.label_prefix[1]
        }}</span>
      </slot>
      <input
        type="number"
        v-model="dataInput"
        v-on:focusout="onChange"
        :min="cmpMinValue"
        :max="cmpMaxValue"
        :step="cmpStepValue"
      />
      <span>{{ getCactusString(cmpConfig.component.decorator.label_unit) }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import expertviewMixin from './experviewMixin';

export default {
  name: 'cwSplitBoxItem',
  mixins: [expertviewMixin],
  props: {
    cmpConfig: {
      type: Object,
      default: () => {},
      required: true
    },
    fwParams: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      selectedData: undefined,
      rulesValue: [],
      dataInput: undefined
    };
  },
  created() {
    this.$log.debug('cwSplitBoxItem::created()', this.cmpConfig, this.fwParams);

    if (this.ruleSubscriber.length > 0) {
      this.applyRules();
      this.applyRuleProvider(
        (this.dataInput =
          this.applyTransformations(this.valueFromFw) || this.cmpConfig.value.default.default)
      );
    }

    this.onChange();
  },
  computed: {
    ...mapGetters(['getRule']),

    cmpMinValue() {
      return Number(this.cmpConfig.value.default.restrictions.min_value) || undefined;
    },

    cmpMaxValue() {
      return Number(this.cmpConfig.value.default.restrictions.max_value) || undefined;
    },
    cmpStepValue() {
      return Number(this.cmpConfig.value.default.restrictions.step) || undefined;
    }
  },
  methods: {
    onChange() {
      // check and adjust value if necessary
      // if value return NAN/UNDEFINED sent 0
      let valueWithAppliedRule = this.dataInput || 0;

      if (this.ruleSubscriber.length > 0) {
        this.ruleSubscriber.forEach(rule => {
          // check if not lower than min, otherwise take min
          if (rule.target === 'max_value') {
            if (this.dataInput > Number(this.getRule(rule.rule[0]))) {
              valueWithAppliedRule = Number(this.getRule(rule.rule[0]));
            }
          }

          if (rule.target === 'min_value') {
            if (this.dataInput < this.getRule(rule.rule[0])) {
              valueWithAppliedRule = this.getRule(rule.rule[0]);
            }
          }
        });
      }

      if (this.cmpMinValue) {
        valueWithAppliedRule =
          valueWithAppliedRule < this.cmpMinValue ? this.cmpMinValue : valueWithAppliedRule;
      }

      if (this.cmpMaxValue) {
        valueWithAppliedRule =
          valueWithAppliedRule > this.cmpMaxValue ? this.cmpMaxValue : valueWithAppliedRule;
      }

      // this.dataInput = valueWithAppliedRule.toFixed(this.cmpDecimals);
      this.dataInput = valueWithAppliedRule;
      this.applyRuleProvider(valueWithAppliedRule);

      this.$log.debug('cwSplitBoxItem::valueChanged', {
        app: this.fwParams.app,
        parameter: this.fwParams.param,
        value: parseInt(this.applyReverseTransformations(valueWithAppliedRule))
      });

      this.setExpertViewParams({
        app: this.fwParams.app,
        parameter: this.fwParams.param,
        value: parseInt(this.applyReverseTransformations(valueWithAppliedRule))
      });
    }
  }
};
</script>

<style scoped lang="scss">
.cwSplitBoxItem {
  .input-group {
    position: relative;
    display: table;
    border-collapse: separate;
  }
  input {
    border: 0;
    width: 40%;
    background: none;
    @include textSmall;
    color: $petrol;
    text-align: right;
  }
}
</style>
